import React, { useEffect } from "react";
import DownloadIcon from "mdi-react/TrayArrowDownIcon";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import PdfGenerator from "./DownloadPdf";
import { useState } from "react";
import classes from "../commonGrid.module.css";
import Excel from "exceljs";
import { saveAs } from "file-saver";
import { useSelector } from "react-redux";
import { useExcelExport } from "./useExcelExport";

const DownloadExcel = ({ title, headerGroups, rows, totalSectionArr }) => {
  const selectedAccount = useSelector((state) => state.account.selectedAccount);
  const user = useSelector((state) => state.RS_Authentication.user);
  const [rowVal, setRowVal] = useState([]);
  const [col, setCol] = useState([]);
  const [logo, setLogo] = useState(null);
  const { exportToExcel, isExporting } = useExcelExport();
  const logoUrl = getPath();
  const isBroadviewAccount = user.details.email?.includes("broadview");

  useEffect(() => {
    function getExcel() {
      // HEADERS
      const localCol = [];
      const headers = [];
      headerGroups?.forEach((headerGroup) => {
        const headerRow = [];
        if (headerGroup.headers) {
          headerGroup.headers.forEach((column) => {
            headerRow.push(...getHeader(column));
            headers.push(column?.field);
          });
        }
        localCol.push(headerRow.map((data) => data.value));
      });

      // FILTERED ROWS
      const localrow = [];
      rows?.forEach((row) => {
        if (row.subRows && row.subRows.length > 0) {
          row.subRows.forEach((subRow) => {
            const dataRow = [];
            Object.values(subRow.values).forEach((value) => {
              dataRow.push({
                value,
                type: typeof value === "number" ? "number" : "string",
              });
            });
            localrow.push(dataRow.map((data) => data.value));
          });
        } else {
          const dataRow = [];
          // Object.values(row.values).forEach((value) => {
          //   dataRow.push({
          //     value,
          //     type: typeof value === "number" ? "number" : "string",
          //   });
          // });
          Object.entries(row.values).forEach(([key, value]) => {
            if (headers?.includes(key)) {
              dataRow.push({
                value,
                type: typeof value === "number" ? "number" : "string",
              });
            }
          });
          localrow.push(dataRow.map((data) => data.value));
        }
      });

      setCol(localCol);
      setRowVal(localrow);
    }

    getExcel();
    // Ensure no dependencies cause unnecessary re-renders
  }, [headerGroups, rows]); // Removed col and rowVal as dependencies

  useEffect(() => {
    async function fetchLogo() {
      if (logoUrl && !logo) {
        try {
          const base64 = await getLogoBase64(logoUrl);
          setLogo(base64);
        } catch (error) {
          console.error("Error loading logo image:", error);
        }
      }
    }
    fetchLogo();
  }, [logoUrl]);

  const handleClick = () => {
    // getExcelWithImage({
    //   selectedAccount,
    //   title,
    //   headerGroups,
    //   rows,
    // });
    exportToExcel({ rows, headerGroups, selectedAccount, title });
  };

  return (
    <OverlayTrigger
      placement={"bottom"}
      rootClose={true}
      trigger="click"
      overlay={
        <Popover
          className="w-5 border-0 shadow-lg rounded"
          style={{ zIndex: "1080" }}
        >
          <Popover.Header className={classes.pOHeader}>
            <div className="d-flex justify-content-between">
              <div className="d-flex">Download</div>
            </div>
          </Popover.Header>
          <Popover.Body className={classes.pOHeader}>
            <p
              role="button"
              className="linkClick cursor-pointer text-decoration-underline"
              onClick={handleClick}
            >
              {isExporting ? "Downloading..." : "Download Excel"}
            </p>
            {/* {rowVal?.length > 0 && (
              <PdfGenerator
                title={title}
                col={col[0]}
                row={rowVal}
                totalSectionArr={totalSectionArr}
              />
            )} */}
            {logo ? (
              <PdfGenerator
                logoBase64={logo}
                col={col}
                row={rowVal}
                totalSectionArr={totalSectionArr}
                title={title}
                selectedAccount={selectedAccount}
                isBroadviewAccount={isBroadviewAccount}
              />
            ) : (
              <div>Loading...</div>
            )}
          </Popover.Body>
        </Popover>
      }
    >
      <Button variant="secondary">
        <DownloadIcon />
      </Button>
    </OverlayTrigger>
  );
};

export default DownloadExcel;
function getHeader(column) {
  if (column.totalVisibleHeaderCount === 1) {
    return [
      {
        value: column.Header,
        type: "string",
      },
    ];
  } else {
    const span = [...Array(column.totalVisibleHeaderCount - 1)]?.map(() => ({
      value: "",
      type: "string",
    }));
    return [
      {
        value: column.Header,
        type: "string",
      },
      ...span,
    ];
  }
}
const loadImageAsBase64 = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};
async function getExcelWithImage({
  selectedAccount,
  title,
  headerGroups,
  rows,
}) {
  const workbook = new Excel.Workbook();
  const worksheet = workbook.addWorksheet("Data");

  // Load and add an image
  const imageBase64 = await loadImageAsBase64(
    "https://i.ibb.co/6B098Gh/loanlinq.png"
  );
  const imageId = workbook.addImage({
    base64: imageBase64,
    extension: "png",
  });

  worksheet.addImage(imageId, "A1:G5"); // Set the range where you want the image
  worksheet.addRow([` ${selectedAccount?.label} | Superior Loan Servicing`]);
  worksheet.getCell("A7").font = { name: "Arial", size: 24 };
  worksheet.addRow([``]);
  worksheet.addRow([`${title}`]);
  worksheet.getCell("A9").font = { name: "Arial", size: 24 };
  worksheet.addRow([``]);

  // Adding headers
  headerGroups?.forEach((headerGroup) => {
    const headerRow = headerGroup.headers.map((column) =>
      typeof column?.Header === "string" ? `${column?.Header}` : ""
    );
    worksheet.addRow(headerRow);
  });

  // Adding data rows and subrows

  rows?.forEach((row) => {
    if (row.subRows && row.subRows.length > 0) {
      row.subRows?.forEach((subRow) => {
        const dataRow = Object.values(subRow.values).map((value) =>
          // value || value === "0" || value === 0 ? `${value}` : ""
          typeof value === "number"
            ? value || value === "0" || value === 0
              ? value
              : ""
            : value || value === "0" || value === 0
            ? `${value}`
            : ""
        );
        worksheet.addRow(dataRow);
      });
    } else {
      let newRowValues = { ...row.values };
      if (row.values?.insurance_info) {
        const badges = {
          Pending: { count: 0, bg: "yellow", color: "black", text: "Pending" },
          "Forced Placed": {
            count: 0,
            bg: "blue",
            color: "white",
            text: "Forced Placed",
          },
          Insured: { count: 0, bg: "green", color: "white", text: "Insured" },
          Expired: { count: 0, bg: "red", color: "white", text: "Expired" },
        };

        // Update counts based on value array
        row.values.insurance_info?.forEach((data) => {
          if (data?.includes("Pending")) badges.Pending.count += 1;
          else if (data?.includes("blue-green"))
            badges["Forced Placed"].count += 1;
          else if (data?.includes("green")) badges.Insured.count += 1;
          else badges.Expired.count += 1;
        });

        // Function to generate badge components
        const generateBadges = () =>
          Object.entries(badges)
            .map(([, { count, text }]) => (count ? `${count} ${text}` : null))
            .filter(Boolean)
            .join(", ");
        newRowValues = { ...row.values, insurance_info: generateBadges() };
      }

      const dataRow = Object.values(newRowValues).map((value) =>
        // value || value === "0" || value === 0 ? `${value}` : ""
        typeof value === "number" ? Number(value) : value
      );
      worksheet.addRow(dataRow);
    }
  });

  if (rows.length === 0) {
    worksheet.addRow(["No data"]);
  }

  // Write to a file
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), `${title || "LoanLinq"}.xlsx`);
}

async function getLogoBase64(path) {
  const res = await fetch(path);
  const blob = await res.blob();
  return await new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

function getPath() {
  if (window.location.href.toLowerCase().includes("localhost")) {
    return "http://localhost:3000/assets/loanlinq.png";
  } else if (window.location.href.toLowerCase().includes("uat")) {
    return "https://uat.loanlinq.com/assets/loanlinq.png";
  } else if (window.location.href.toLowerCase().includes("loanlinq.com")) {
    return "https://loanlinq.com/assets/loanlinq.png";
  }
}
